(function () {
  const KEY = "line_user_id";
  const CONNECT_PAGE = "/pages/liff"; // Handle created from template page.liff.json

  function inLineWebView() {
    try {
      const ua = navigator.userAgent || "";
      // iOS/Android LINE app embeds 'Line/' or 'LIFF' in UA
      return /Line\//i.test(ua) || /LIFF/i.test(ua);
    } catch (e) {
      return false;
    }
  }

  function onLiffEntryPage() {
    try {
      return location.pathname.startsWith(CONNECT_PAGE);
    } catch (e) {
      return false;
    }
  }

  async function readCart() {
    try {
      const res = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!res.ok) return { attributes: {} };
      return res.json();
    } catch (e) {
      return { attributes: {} };
    }
  }

  async function writeCartAttr(id) {
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ attributes: { [KEY]: id } }),
      });
    } catch (e) {}
  }

  async function ensureCartHasLineId() {
    let id;
    try {
      id = localStorage.getItem(KEY);
    } catch (e) {}
    if (!id) return false;

    const cart = await readCart();
    if (cart && cart.attributes && cart.attributes[KEY] === id) return true;
    await writeCartAttr(id);
    return true;
  }

  function shouldGuardCheckout() {
    try {
      return !localStorage.getItem(KEY);
    } catch (e) {
      return true;
    }
  }

  function isCheckoutClickTarget(target) {
    if (!target) return false;
    const el = target.closest(
      '[data-checkout], a[href$="/checkout"], button[name="checkout"], [name="checkout"]'
    );
    return !!el;
  }

  function toggleDynamicCheckoutVisibility(linked) {
    try {
      const nodes = document.querySelectorAll(
        ".additional-checkout-buttons, #dynamic-checkout, #dynamic-checkout-cart"
      );
      nodes.forEach((el) => {
        el.style.display = linked ? "" : "none";
      });
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    const linked = !shouldGuardCheckout();
    toggleDynamicCheckoutVisibility(linked);

    // If opened inside LINE and not yet linked, force the LIFF flow
    if (inLineWebView() && !linked && !onLiffEntryPage()) {
      const ret = location.pathname + location.search + location.hash;
      // Avoid history back loop
      location.replace(`${CONNECT_PAGE}?redirect=${encodeURIComponent(ret)}`);
      return;
    }

    ensureCartHasLineId().then(() => toggleDynamicCheckoutVisibility(true));
  });

  document.addEventListener(
    "click",
    function (e) {
      if (!isCheckoutClickTarget(e.target)) return;
      if (!shouldGuardCheckout()) return; // Linked, allow checkout

      e.preventDefault();
      // Route through the LIFF connect page to capture the user id first
      window.location.href = CONNECT_PAGE;
    },
    true
  );

  // Intercept cart form submissions that trigger checkout
  document.addEventListener(
    "submit",
    function (e) {
      try {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const hasCheckoutField = form.querySelector('[name="checkout"]');
        if (!hasCheckoutField) return;
        if (!shouldGuardCheckout()) return; // Linked, allow
        e.preventDefault();
        window.location.href = CONNECT_PAGE;
      } catch (err) {
        /* ignore */
      }
    },
    true
  );
})();
